import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Fasongqian"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_569_8438)"><path d="M19.6976 12.4167L4.33617 5.38636L9.08852 12.4191L4.67308 19.7839L19.6976 12.4167Z" fill="#BDC3CD" stroke="#BDC3CD" stroke-width="1.66667" stroke-linejoin="bevel"></path><path d="M7.3913 12.4167L12.4242 12.4216" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_569_8438"><rect width="20" height="20" fill="white" transform="translate(2 2)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var fasongqian = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { fasongqian as default };
